export default __webpack_public_path__ + "static/media/dilution.f9e32295.jpg";